<template>
  <el-row>
    <el-col :span="24">
      <el-button
        class="pull-right"
        size="mini"
        type="primary"
        :disabled="selection.length < 1"
        @click="requeue">Requeue
      </el-button>
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="queue && queue.data"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column type="expand">
          <template slot-scope="props">
            <log-on-order :order="props.row.item.order.rec"/>
            <log-on-errors :errors="props.row.item.errors"/>
          </template>
        </el-table-column>
        <el-table-column prop="item.order.rec.header.shiptocountry"
                         label="Country"
                         width="250"/>
        <el-table-column prop="item.id" label="Shopify Order ID"/>
        <el-table-column label="Latest Error">
          <template slot-scope="props">
            {{lastErrorDate(props.row.item.errors)}}
          </template>
        </el-table-column>
        <el-table-column prop="item.errors.length" label="# Errors"/>
      </el-table>
      <br>
      <el-pagination
        background
        layout="prev, pager, next, ->, total"
        :page-size="queue.per_page"
        :total="queue.total"
        :page-count="queue.last_page"
        :current-page="queue.current_page"
        @current-change="currentChangeHandler"
        @size-change="sizeChangeHandler">
      </el-pagination>
    </el-col>
  </el-row>
</template>

<script>
  import axios, { RepositoryError } from "../../repositories";
  import LogOnOrder from '../LogOn/LogOnOrder';
  import LogOnErrors from '../LogOn/LogOnErrors';
  import moment from 'moment';

  export default {
    name: 'OrderInfoObjectFailedTable',
    mounted() {
      this.fetch();
    },
    data() {
      return {
        refreshInterval: null,
        loading: true,
        queue: {},
        page: 1,
        limit: 10,
        selection: [],
      };
    },
    props: {
      refresh: {
        type: Boolean,
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
    },
    components: {
      LogOnOrder,
      LogOnErrors,
    },
    methods: {
      async fetch() {
        try {
          this.loading = true;
          this.queue = await this.getQueue();
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        } finally {
          this.loading = false;
        }
      },
      async getQueue() {
        try {
          const response = await axios.get(
            '/kitsilano/queues/manage', {
            params: {
              name: this.name,
              page: this.page,
              limit: this.limit,
            },
          });

          return response.data;
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        }
      },
      async requeue() {
        try {
          this.loading = true;
          let ids = [];

          for (let i = 0; i < this.selection.length; i++) {
            ids.push(this.selection[i].id);
          }

          await axios.put('/kitsilano/queues/requeue', {
            name: this.name,
            ids: ids,
          });

          await this.fetch();
        } catch (err) {
          if (err instanceof RepositoryError) {
            return;
          }

          throw err;
        } finally {
          this.loading = false;
        }
      },
      currentChangeHandler(page) {
        this.page = page;
        this.fetch();
      },
      sizeChangeHandler(limit) {
        this.page = limit;
        this.fetch();
      },
      lastErrorDate(errors) {
        if (errors.length < 1) {
          return '';
        }

        const moments = errors.map(e => moment.utc(e.created_at));
        const latest = moment.max(moments);

        return latest.local().format('MMMM Do YYYY h:mm:ss a');
      },
      handleSelectionChange(val) {
        this.selection = val;
      },
    },
    watch: {
      refresh: function(val) {
        if (val) this.fetch();
      },
    },
  };
</script>
